// project-imports
import {
    GET_INTERVIEW_CATEGORIES_DATA_BEGIN,
    GET_INTERVIEW_CATEGORIES_DATA_SUCCESS,
    GET_INTERVIEW_CATEGORIES_DATA_FAILURE,
    GET_INTERVIEW_SERIES_DATA_BEGIN,
    GET_INTERVIEW_SERIES_DATA_SUCCESS,
    GET_INTERVIEW_SERIES_DATA_FAILURE,
    GET_INTERVIEW_QUESTIONS_DATA_BEGIN,
    GET_INTERVIEW_QUESTIONS_DATA_SUCCESS,
    GET_INTERVIEW_QUESTIONS_DATA_FAILURE,
    GET_USER_INTERACTION_BY_SERIES_BEGIN,
    GET_USER_INTERACTION_BY_SERIES_SUCCESS,
    GET_USER_INTERACTION_BY_SERIES_FAILURE,
    GET_SERIES_INTERACTION_BY_USER_BEGIN,
    GET_SERIES_INTERACTION_BY_USER_SUCCESS,
    GET_SERIES_INTERACTION_BY_USER_FAILURE,
    ADD_USER_FEEDBACK_BEGIN,
    ADD_USER_FEEDBACK_SUCCESS,
    ADD_USER_FEEDBACK_FAILURE,
    GET_TRENDING_INTERVIEW_SERIES_BEGIN,
    GET_TRENDING_INTERVIEW_SERIES_SUCCESS,
    GET_TRENDING_INTERVIEW_SERIES_FAILURE,
    UPSERT_INTERVIEW_SERIES_USER_INTERACTION_BEGIN,
    UPSERT_INTERVIEW_SERIES_USER_INTERACTION_SUCCESS,
    UPSERT_INTERVIEW_SERIES_USER_INTERACTION_FAILURE,
} from "../constants/actions";

// State variable initialization
export const initialState = {
    isLoading: false,
    isQuestionLoading: false,
    isInteractionLoading: false,
    isSeriesFeedbackLoading: false,
    isError: null,
    isSeriesFeedbackError: null,
    interviewCategories: [],
    interviewSeries: [],
    interviewQuestions: [],
    userInteractionBySeries: [],
    seriesInteractionByUser: [],
    seriesFeedbackByUser: [],
    trendingInterviewseries: [],
};

const interviewReducer = (state = initialState, action) => {
    // For Get Interview-Categories
    if (action.type === GET_INTERVIEW_CATEGORIES_DATA_BEGIN) {
        // Set loading state
        return {
            ...state,
            isLoading: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_INTERVIEW_CATEGORIES_DATA_SUCCESS) {
        // Update state with all data
        return {
            ...state,
            isLoading: false,
            interviewCategories: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_INTERVIEW_CATEGORIES_DATA_FAILURE) {
        // Set error state
        return {
            ...state,
            isLoading: false,
            isError: action.payload,
        };
    }


    // For Get Interview-Series
    if (action.type === GET_INTERVIEW_SERIES_DATA_BEGIN) {
        // Set loading state
        return {
            ...state,
            isLoading: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_INTERVIEW_SERIES_DATA_SUCCESS) {
        // Update state with all data
        return {
            ...state,
            isLoading: false,
            interviewSeries: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_INTERVIEW_SERIES_DATA_FAILURE) {
        // Set error state
        return {
            ...state,
            isLoading: false,
            isError: action.payload,
        };
    }


    // For Get Interview-Questions
    if (action.type === GET_INTERVIEW_QUESTIONS_DATA_BEGIN) {
        // Set loading state
        return {
            ...state,
            isQuestionLoading: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_INTERVIEW_QUESTIONS_DATA_SUCCESS) {
        // Update state with all data
        return {
            ...state,
            isQuestionLoading: false,
            interviewQuestions: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_INTERVIEW_QUESTIONS_DATA_FAILURE) {
        // Set error state
        return {
            ...state,
            isQuestionLoading: false,
            isError: action.payload,
        };
    }

    // For Set UserInteraction
    if (action.type === UPSERT_INTERVIEW_SERIES_USER_INTERACTION_BEGIN) {
        // Set loading state

        return {
            ...state,
            isInteractionLoading: action.payload,
            isError: null,
        };
    }

    if (action.type === UPSERT_INTERVIEW_SERIES_USER_INTERACTION_SUCCESS) {
        // Update state with all data
        const payload = action?.payload;

        if (!payload) return state; // Guard clause if payload is missing

        let existingData = state?.userInteractionBySeries || [];
        const index = (state?.userInteractionBySeries || []).findIndex((i) => (i?.seriesId === payload?.seriesId && (i?.userId === payload?.userId)));

        let updatedData;
        if (payload && index !== -1) {
            // Replace the item by creating a new array
            updatedData = existingData?.map((item, i) => i === index ? payload : item);
        } else {
            // Append the item by creating a new array
            updatedData = [...existingData, payload];
        }

        return {
            ...state,
            isInteractionLoading: false,
            userInteractionBySeries: updatedData,
            isError: null,
        };
    }

    if (action.type === UPSERT_INTERVIEW_SERIES_USER_INTERACTION_FAILURE) {
        // Set error state
        return {
            ...state,
            isInteractionLoading: false,
            isError: action.payload,
        };
    }

    // For Get UserInteraction by series BookMark
    if (action.type === GET_USER_INTERACTION_BY_SERIES_BEGIN) {
        // Set loading state
        return {
            ...state,
            isInteractionLoading: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_USER_INTERACTION_BY_SERIES_SUCCESS) {
        // Update state with all data
        return {
            ...state,
            isInteractionLoading: false,
            userInteractionBySeries: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_USER_INTERACTION_BY_SERIES_FAILURE) {
        // Set error state
        return {
            ...state,
            isInteractionLoading: false,
            isError: action.payload,
        };
    }

    // For Get series Bookmarks by user
    if (action.type === GET_SERIES_INTERACTION_BY_USER_BEGIN) {
        // Set loading state
        return {
            ...state,
            isInteractionLoading: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_SERIES_INTERACTION_BY_USER_SUCCESS) {
        // Update state with all data
        return {
            ...state,
            isInteractionLoading: false,
            seriesInteractionByUser: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_SERIES_INTERACTION_BY_USER_FAILURE) {
        // Set error state
        return {
            ...state,
            isInteractionLoading: false,
            isError: action.payload,
        };
    }

    // For Set series-feedback
    if (action.type === ADD_USER_FEEDBACK_BEGIN) {
        // Set loading state

        return {
            ...state,
            isSeriesFeedbackLoading: action.payload,
            isSeriesFeedbackError: null,
        };
    }

    if (action.type === ADD_USER_FEEDBACK_SUCCESS) {

        return {
            ...state,
            isSeriesFeedbackLoading: false,
            isSeriesFeedbackError: null,
        };
    }

    if (action.type === ADD_USER_FEEDBACK_FAILURE) {
        // Set error state
        return {
            ...state,
            isSeriesFeedbackLoading: false,
            isSeriesFeedbackError: action.payload,
        };
    }

    // For Get Trending-Interview Series
    if (action.type === GET_TRENDING_INTERVIEW_SERIES_BEGIN) {
        // Set loading state
        return {
            ...state,
            isLoading: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_TRENDING_INTERVIEW_SERIES_SUCCESS) {
        // Update state with all data
        return {
            ...state,
            isLoading: false,
            trendingInterviewseries: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_TRENDING_INTERVIEW_SERIES_FAILURE) {
        // Set error state
        return {
            ...state,
            isLoading: false,
            isError: action.payload,
        };
    }
    return state;

};

export default interviewReducer;
